import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { MainComponent } from './components/main/main.component';
import { HomeThreeComponent } from './../app/components/shop/home-three/home-three.component';


const appRoutes: Routes = [
  {
    path: '',
    component: MainComponent, // Main layout component
    children: [
      {
        path: '', // Redirect root path to /home/three
        redirectTo: 'home/three',
        pathMatch: 'full',
      },
      {
        path: 'home/three',
        component: HomeThreeComponent, // HomeThreeComponent is a child of MainComponent
      },
      {
        path: 'home',
        loadChildren: () => import('./components/shop/shop.module').then(m => m.ShopModule),
      },
      {
        path: 'pages',
        loadChildren: () => import('./components/pages/pages.module').then(m => m.PagesModule),
      },
      {
        path: 'blog',
        loadChildren: () => import('./components/blog/blog.module').then(m => m.BlogModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'home/three', // Redirect invalid paths to /home/three
  },
];


@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(appRoutes, { useHash: true, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
